import { useCallback, useEffect, useState, Fragment } from "react";
import {
  Grid,
  TextField,
  IconButton,
  InputAdornment,
  Box,
} from "@mui/material";
import { StyledStack, StyledTitle } from "./SendMessage.style";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import GenarateHeadCell from "helper/generate-head-cell";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import Toast from "helper/toast";
import { getTeacherStudentRequest, sendMessageRequest } from "api/requests";
import PaginationCM from "components/shared/Pagination";
import useSelected from "hooks/use-selected";
import DeleteModal from "components/shared/Modal/Delete";
import { PAGINATION_LIMIT } from "constants";
import { messageSchema } from "validations";
import { Close, Search } from "@mui/icons-material";
import { theme } from "styles/mui-config";

const headCells = GenarateHeadCell("message_user_list");
let initialPage = 1;

export default function SendMessage() {
  const selectCTX = useSelected();


  // all student datra state
  const [users, setUsers] = useState({ data: [], count: 0 });

  const { request, loading, setLoading } = useHttp();

  //page inition stat
  const [page, setPage] = useState(initialPage);

  //modal stat
  const [showSendModal, setshowSendModall] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(messageSchema),
  });

  // onOpen & onClose modal handler
  const handelShowModal = () => setshowSendModall((state) => !state);

  ///////////// send message for selected students /////////////
  const onSubmit = async (values) => {
    values = {
      type: "message",
      text_message: values.text,
      students_id: selectCTX.selectedItems,
      title: values.title ?? "پیام جدید",
    };
    const res = await request({
      url: sendMessageRequest,
      values,
    });

    if (res) {
      reset({
        text: "",
        title: "",
        search: ""
      });
      selectCTX.removeItems();
      Toast({ type: "success" });
    }
  };
  const handelSearch = (e) => {
    if (!e) {
      reset({
        search: "",
        title: getValues("title"),
        text: getValues("text"),
      })
      return getUsers();
    }

    getUsers(getValues("search"));
  };

  /////////////get users/////////////
  const getUsers = useCallback(
    async (search) => {
      setLoading(true);
      const res = await request({
        url: getTeacherStudentRequest,
        values: {
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
          limit: search ? 100 : PAGINATION_LIMIT,
          search: search ?? null,
        },
        isMulty: true,
      });
      if (res) {
        let transformedData = res.data.map((items) => ({
          id: items.id,
          full_name: `${items.first_name} ${items.last_name}`,
          father_name:
            items.father_first_name !== "null" && items.father_name
              ? items.father_name
              : "ثبت نشده",
          national_code:
            items.national_code !== "null" && items.national_code
              ? items.national_code
              : "ثبت نشده",
          section:
            items.section !== "null" && items.section
              ? items.section
              : "ثبت نشده",
          level:
            items.level !== "null" && items.level ? items.level : "ثبت نشده",
          mobile_number:
            items.mobile_number !== "null" && items.mobile_number
              ? items.mobile_number
              : "ثبت نشده",
        }));

        setUsers({ data: transformedData, count: res.count });
        setLoading(false);
      }
    },
    [page]
  );

  useEffect(() => {
    getUsers();
  }, [page, getUsers]);

  useEffect(() => {
    selectCTX.removeItems();
    return () => {
      selectCTX.removeItems();
    };
  }, []);

  return (
    <DrawerCM title="ارسال پیام" $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <StyledStack>
            <StyledTitle>ارسال پیام</StyledTitle>
            <Grid container>
              <Grid item xs={12} p={1.5}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="title"
                  {...register("title")}
                  error={Boolean(errors.title)}
                  helperText={errors.title?.message}
                />
              </Grid>
              <Grid item xs={12} pt={3} p={1.5}>
                <TextField
                  label="متن"
                  variant="outlined"
                  multiline
                  rows={6}
                  fullWidth
                  inputProps={{ readOnly: false }}
                  id="text"
                  {...register("text")}
                  error={Boolean(errors.text)}
                  helperText={errors.text?.message}
                />
              </Grid>
            </Grid>
          </StyledStack>
          <Grid container>
            <StyledStack>
              <Grid item xs={12} pt={3} p={1.5}>
                <TextField
                  label="جست و جو"
                  variant="outlined"
                  fullWidth
                  id="search"
                  {...register("search")}
                  InputProps={{
                    endAdornment: (
                      <>
                        <InputAdornment position="start">
                          <IconButton onClick={() => handelSearch(false)}>
                            <Close
                              color="primary"
                              sx={{ transform: "rotate(180deg)" }}
                            />
                          </IconButton>
                        </InputAdornment>
                        <Box
                          sx={{
                            width: "2px",
                            height: "20px",
                            backgroundColor: theme.palette.primary.main,
                          }}
                        ></Box>
                        <InputAdornment position="end">
                          <IconButton onClick={handelSearch}>
                            <Search color="primary" />
                          </IconButton>
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
              </Grid>
            </StyledStack>
            <Grid item xs={12} my={2}>
              <TableCM
                title="انتخاب کاربران"
                rows={users.data}
                headCells={headCells}
                isSelectable
                onSubmit={handleSubmit(onSubmit)}
                onDelete={() => selectCTX.removeItems()}
                onSubmitAll={() => {
                  selectCTX.setSelectedItems(users.data.map((item) => item.id));
                }}
                page={page}
              />
            </Grid>
            <Grid item xs={12}>
              <PaginationCM
                handleChange={(e, val) => {
                  initialPage = val;
                  setPage(val);
                }}
                page={page}
                count={users.count}
              />
            </Grid>
          </Grid>
          <DeleteModal
            show={showSendModal}
            onClose={handelShowModal}
            title="آیا میخواهد این متن را برای همه ارسال کنید؟"
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
